<template>
  <div class="application">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="National Exam" />
    </header>
    <main>
      <section class="section-details" data-aos="fade-up">
        <b-container>
          <h4>{{ $t("About National Exam") }}</h4>
          <ul class="steps-ul">
            <li>
              {{ $t("Details of the Iraqi National Proficiency Test: This is an online service dedicated to registering for the Iraqi National Proficiency Test (Arabic, English, and Computer Skills) for students wishing to pursue postgraduate studies at Iraqi universities. The test is administered at a number of accredited centers located throughout the various Iraqi governorates.") }}
            <a style="color: red !important;"
            href="https://ints-auth.uob.edu.iq/Identity/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%3Fclient_id%3DBookingPage%26redirect_uri%3Dhttps%253A%252F%252Finpt.rdd.edu.iq%252Fsignin-oidc%26response_type%3Dcode%26scope%3Dopenid%2520profile%2520email%2520roles%26code_challenge%3DWWhqt6OXCSH9ZuAd8Y_wx1ZFrSv_OZpp8sBetd7RD3Q%26code_challenge_method%3DS256%26response_mode%3Dform_post%26nonce%3D639066600850407711.YmExODQ5YzctOTk4ZC00M2Y3LWEzNTMtNDVkYjM4ZDk4ZmRmYjg0MTY3OWUtYmNjZi00NWIxLTgyNzAtNzExNDkzYjdiZGZk%26state%3DCfDJ8K4FqTPWJ71NsMVP_-T8XgM4EsfYXMBYQJsDgaDy6VdQ5MG9Ndsa_r4IkXi5efITlxyIK94b5PSbrIqISuLvD9MLrRhgk6Oii3GcKLX-1TFeYAIqd4CEihBY-9XT_yhxsxFX107gg6rDinH4GP8xUk20NKOqhc8Lif0-XfNt0eV6X3Gz__cn5xZ_4Mr0EZdnkwr-ez1i9bna3W6_VBHczm6DPzSIrJwp5uetq8vPfdMJhtNdWTvoqPyFPs_EQcwCh_yL3bItig6tVlXbQjciApcW07ll66U2bn5fZJXdsMH8TODGMvxfyB8y_NpSwA6J43zA0iDLIoJiV5m9AOl58JqpwSkZ5MDhBuNA98moAL_Si7mbp6EZMXA5OQ_4my7GqA%26x-client-SKU%3DID_NET8_0%26x-client-ver%3D8.2.1.0"
            target="_blank"
          >
          {{ $t("Apply Now") }}
          </a>
            </li>
            
            <li>{{ $t("How to apply: Access the service by clicking the Access Service link. Log in or create an account on the Iraqi National Proficiency Test platform. Accurately enter the required information (exam type, governorate, university). Click the Download Form button. A document containing a QR code will be sent to you. You can print this document or save it on your phone to track your application status. Visit the Continuing Education Center at the institution where you applied to confirm your booking within 72 hours of the test date. Failure to confirm your booking within this timeframe will result in cancellation.") }}
              <a style="color: red !important;"
            href="https://www.youtube.com/watch?v=ayVMXkaYy0U"
            target="_blank"
          >
          {{ $t("How to Apply Link") }}
          </a></li>
            <li>{{ $t("Required Documents for the Service: (National ID or Passport) must be presented during reservation confirmation and test attendance.") }}</li>
            <li>
              {{ $t("Taking the exam at Al-Nisour University: Al-Nisour University offers a unique educational environment for the National Exam.") }}
            </li>
          </ul>
        </b-container>
      </section>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
// import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    FooterComponent,
    MobileNav,
    
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
  if(localStorage.getItem("lang")=="en"){
    document.title = ` Al-Nisour University   - National Exam`;
    document.querySelector('meta[name="title"]').setAttribute("content","National Exam");
    document.querySelector('meta[name="description"]').setAttribute("content", "The first steps of registration is to enter the private university education portal through the password and the exam in the event that the student is a graduate of the current academic year, but if the student is a graduate of previous years, he must go to the counseling center with the identification documents, and endorsement of graduation from the preparatory school for the purpose of obtaining a number Exam and password.");
    document.querySelector('meta[property="og:title"]').setAttribute("content","National Exam");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "The first steps of registration is to enter the private university education portal through the password and the exam in the event that the student is a graduate of the current academic year, but if the student is a graduate of previous years, he must go to the counseling center with the identification documents, and endorsement of graduation from the preparatory school for the purpose of obtaining a number Exam and password.");
    }else{
    document.title = `جامعة النسور  - الامتحان الوطني`;
    document.querySelector('meta[name="title"]').setAttribute("content","الية التسجيل");
    document.querySelector('meta[name="description"]').setAttribute("content", "أولى خطوات التسجيل هي الدخول إلى بوابة التعليم الجامعي الأهلي من طريق الرقم السري والامتحاني في حال كان الطالب من خريجي العام الدراسي الحالي، أما إذا كان الطالب من خريجي السنوات السابقة فيتوجب عليه الذهاب إلى المركز الإرشادي مستصحباً المستمسكات الثبوتية، وتأييد تخرج من الإعدادية لغرض استحصال رقم امتحاني ورقم سري");
    document.querySelector('meta[property="og:title"]').setAttribute("content","الامتحان الوطني");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "أولى خطوات التسجيل هي الدخول إلى بوابة التعليم الجامعي الأهلي من طريق الرقم السري والامتحاني في حال كان الطالب من خريجي العام الدراسي الحالي، أما إذا كان الطالب من خريجي السنوات السابقة فيتوجب عليه الذهاب إلى المركز الإرشادي مستصحباً المستمسكات الثبوتية، وتأييد تخرج من الإعدادية لغرض استحصال رقم امتحاني ورقم سري");
    }
    // document.getElementById("icon").setAttribute("href",`${filesUrl}favicon.ico`); 
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
};
</script>
